
function moveAutomaticallyAlert () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/move-automatically-alert/move-automatically-alert.html?$$REVISION$$'
  }
}
export { moveAutomaticallyAlert }
